import { useEffect, useState } from 'react';

const CHANNEL_BY_TYPE = {
    ALERT_EMAIL: 'email',
    ALERT_SMS: 'sms',
    ALERT_TELEGRAM: 'telegram',
};

/**
 * Alert types depend on what the API reports as usable (channels).
 * While channels are unknown (null) every type is considered available,
 * the API validates it again when the automation is saved.
 */
export function isActionAvailable(type, channels) {
    const channel = CHANNEL_BY_TYPE[type];
    if (!channel || !channels) return true;
    return !!channels[channel];
}

/**
 * props:
 * - type
 * - channels
 * - onChange
 */
function ActionType(props) {
    const [type, setType] = useState('');

    useEffect(() => {
        setType(props.type);
    }, [props.type]);

    const emailAvailable = isActionAvailable('ALERT_EMAIL', props.channels);
    const telegramAvailable = isActionAvailable(
        'ALERT_TELEGRAM',
        props.channels,
    );

    return (
        <select
            id="type"
            className="form-select"
            value={type}
            onChange={props.onChange}
        >
            <option value="ALERT_EMAIL" disabled={!emailAvailable}>
                {emailAvailable
                    ? 'Alert via Email'
                    : 'Alert via Email (set up your SMTP in Settings)'}
            </option>
            {props.channels && props.channels.sms && (
                <option value="ALERT_SMS">Alert via SMS</option>
            )}
            <option value="ALERT_TELEGRAM" disabled={!telegramAvailable}>
                {telegramAvailable
                    ? 'Alert via Telegram'
                    : 'Alert via Telegram (not available)'}
            </option>
            <option value="ORDER">Place Order</option>
            <option value="TRAILING">Place Trailing (Spot)</option>
            <option value="WITHDRAW">Withdraw Crypto</option>
        </select>
    );
}

export default ActionType;
